export default __webpack_public_path__ + "static/media/emoji-laptop.342d95f9.svg";